import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineChartLineIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7 16a1.5 1.5 0 0 0 1.5-1.5.7703.7703 0 0 0 0-.15l2.79-2.79h.46l1.61 1.61v.08a1.5001 1.5001 0 1 0 3 0v-.08L20 9.5A1.5 1.5 0 1 0 18.5 8a.7671.7671 0 0 0 0 .15l-3.61 3.61h-.16L13 10a1.5 1.5 0 1 0-3 0l-3 3a1.5 1.5 0 1 0 0 3Zm13.5 4h-17V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineChartLineIcon
